// error-handler.interceptor.ts
import { Inject, Injectable } from '@angular/core'
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { Observable, throwError } from 'rxjs'
import { catchError } from 'rxjs/operators'
import { WINDOW } from '@app/services/window.service'
import { PageErrorService } from '@app/pages/page-error/service/page-error.service'
import { PageErrorType } from '@app/pages/page-error/classes/page-error-type'
import { FciErrorType, FciErrorTypeHelper } from '@core/api/fci-error-type'

@Injectable({ providedIn: 'root' })
export class ErrorHandlerInterceptor implements HttpInterceptor {
  constructor(
    private pageErrorService: PageErrorService,
    @Inject(WINDOW) private window: Window
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: any) => {
        if (!(error instanceof HttpErrorResponse)) {
          return throwError(() => error)
        }

        const skip500 = request.headers.get('X-SKIP-ERROR-HANDLER-500') === 'true'
        if (skip500 && error.status === 500) {
          return throwError(() => error)
        }

        const fciErrorType = FciErrorTypeHelper.stringToEnum(request.headers.get('X-FCI-ErrorType'))

        if (fciErrorType === FciErrorType.convenience || fciErrorType === FciErrorType.transparentSubstitution) {
          return throwError(() => error)
        }

        if (error.url?.indexOf('/assets/i18n/') !== -1) {
          return throwError(() => error)
        }

        // Skip parsing errors for renew endpoint
        if (error.url?.indexOf('/stories/renew') !== -1 && error.message?.includes('parsing')) {
          return throwError(() => error)
        }

        switch (error.status) {
          case 401:
            break
          default: {
            let pageErrorType: PageErrorType
            if (this.window.location.pathname === '/stories') {
              pageErrorType = PageErrorType.stories
            } else if (this.window.location.pathname.indexOf('/stories/connect/') === 0) {
              pageErrorType = PageErrorType.connect
            } else {
              pageErrorType = PageErrorType.default
            }

            this.pageErrorService.show({
              pageErrorType,
              fciErrorType,
            })
          }
        }

        return throwError(() => error)
      })
    )
  }
}
